/****************************************************************************************************
*                                                                                                   *
*   Freshwater v3 CLIENT JS FILE                                                                    *
*                                                                                                   *
*   client specific scripts, this file CAN be edited                                                *
*                                                                                                   *
****************************************************************************************************/

window.addEventListener('load', function(e) {
    if (window.Freshwater) {
        window.Freshwater.console('log', "client js loaded. Event: " + e.type);
    }
});


/************* 
 * BEGIN: LOCATIONS PAGE*
 * ***********/

function initLocationModals() {

    function openModal(modal) {
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("fw-modal-open");
    }

    function closeModal(modal) {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("fw-modal-open");
    }

    document.querySelectorAll("[data-modal-target]").forEach(button => {
        button.addEventListener("click", () => {
            const modal = document.getElementById(button.dataset.modalTarget);
            if (modal) openModal(modal);
        });
    });

    document.querySelectorAll(".fw-modal").forEach(modal => {
        modal.querySelectorAll("[data-close]").forEach(el => {
            el.addEventListener("click", () => closeModal(modal));
        });
    });

    document.addEventListener("keydown", event => {
        if (event.key === "Escape") {
            document.querySelectorAll(".fw-modal.is-open").forEach(closeModal);
        }
    });

}

initLocationModals();

/************* 
 * END: LOCATIONS PAGE*
 * ***********/